<template>
    <div class="information">
        <div :class="padding" class="row">
            <div class="col-md-3 ">
                Назва
            </div>
            <div class="col-md-9">
                <i>{{tender?.name}}</i>
            </div>
        </div>
        
        <div :class="padding" class="row">
            <div class="col-md-3">
                Группа категорії закупки
            </div>
            <div class="col-md-9">
                <i>{{tender?.main_categ?.ua_name}}</i>
            </div>
        </div>
        
        <div :class="padding" class="row">
            <div class="col-md-3">
                Категорія закупки
            </div>
            <div class="col-md-9">
                <i>
                    <span>{{ tender?.human_categories.map(i => i.title).join(' | ') }}</span>
                </i>
            </div>
        </div>
        
        <div :class="padding" class="row">
            <div class="col-md-3">
                Номер службової на проведення тендера
            </div>
            <div class="col-md-9">
                <i>{{tender?.memoramdum_number}}</i>
            </div>
        </div>
        
        <div :class="padding" class="row">
            <div class="col-md-3">
                Початок тендера
            </div>
            <div class="col-md-9">
                <i>{{tender?.date_from}}</i>
            </div>
        </div>
        
        <div :class="padding" class="row">
            <div class="col-md-3">
                Закінчення тендера
            </div>
            <div class="col-md-9">
                <i>{{tender?.date_to}}</i>
            </div>
        </div>
        
        <div :class="padding" class="row">
            <div class="col-md-3">
                Умови оплати
            </div>
            <div class="col-md-9">
                <i>{{tender?.payment?.title}}</i>
            </div>
        </div>
        
        <div :class="padding" class="row ">
            <div class="col-md-3">
                Умови постачання
            </div>
            <div class="col-md-9">
                <i>{{tender?.delivery?.title}}</i>
            </div>
        </div>
        
        <div :class="padding" class="row">
            <div class="col-md-3">
                Очікувана дата постачання
            </div>
            <div class="col-md-9">
                <i>{{tender?.date_delivery}}</i>
            </div>
        </div>
        
        
        <div :class="padding" class="row" v-if="is_reduction">
            <div class="col-md-3">
                Час до закінчення для продовження (хв.)
            </div>
            <div class="col-md-9">
                <i>{{tender?.time_short}}</i>
            </div>
        </div>
        
        
        <div :class="padding" class="row" v-if="is_reduction">
            <div class="col-md-3">
                Час продовження (хв.)
            </div>
            <div class="col-md-9">
                <i>{{tender?.time_long}}</i>
            </div>
        </div>
        
        
        <div :class="padding" class="row" v-if="is_reduction">
            <div class="col-md-3">
                Валюта
            </div>
            <div class="col-md-9">
                <i>{{tender?.currency.name}}</i>
            </div>
        </div>
    
    
    </div>
</template>


<script>
export default {
    name: "tender_info",
    props : {
        tender: {
            type: Object,
            required: true
        }
    },
    
    computed : {
        is_reduction() {
            return this.tender.tender_type === 'second_reduction';
        },
        
        padding () {
            return 'mb-3';
        }
    }
    
}
</script>


<style scoped>

</style>